import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import * as Styled from './AskVeloButton.styles';

const AskVeloButton = ({
  clickstreamProps, messageId = 'dashboard.carousel.card.askVelo.button', ...props
}) => (
  <Styled.ButtonWrapper>
    <Styled.AskVeloButton
      clickstreamProps={clickstreamProps}
      {...props}
    >
      <FormattedMessage id={messageId} />
    </Styled.AskVeloButton>
  </Styled.ButtonWrapper>
);

AskVeloButton.propTypes = {
  to: PropTypes.string,
  href: PropTypes.string,
  clickstreamProps: PropTypes.shape({
    elementName: PropTypes.string
  }),
  messageId: PropTypes.string
};

export default AskVeloButton;
